import { useState, useCallback, useEffect } from "react";
import { useAuth, API } from "../App";
import { useTheme } from "../ThemeContext";
import axios from "axios";
import { toast } from "sonner";
import TeamManagement from "../components/TeamManagement";
import { ProfileSection } from "../components/settings/ProfileSection";
import { ThemeSection, THEMES } from "../components/settings/ThemeSection";
import { LogoSection } from "../components/settings/LogoSection";
import { EmailSection } from "../components/settings/EmailSection";
import { NotificationsSection } from "../components/settings/NotificationsSection";
import { IntegrationsSection } from "../components/settings/IntegrationsSection";
import { SubscriptionSection } from "../components/settings/SubscriptionSection";
import { ReferralSection } from "../components/settings/ReferralSection";
import { SupportSection } from "../components/settings/SupportSection";
import { AboutSection } from "../components/settings/AboutSection";

const Settings = () => {
  const { user } = useAuth();
  const { theme, setTheme, companyLogo, updateLogo } = useTheme();
  const [subscription, setSubscription] = useState(null);

  const fetchSubscription = useCallback(async () => {
    try {
      const res = await axios.get(`${API}/subscription/current`, { withCredentials: true });
      setSubscription(res.data);
    } catch { toast.error("Failed to load subscription"); }
  }, []);

  useEffect(() => { fetchSubscription(); }, [fetchSubscription]);

  const handleThemeChange = (newTheme) => {
    setTheme(newTheme);
    toast.success(`Theme changed to "${THEMES.find(t => t.id === newTheme)?.name}"`);
  };

  return (
    <div className="p-6 md:p-8 animate-fade-in">
      {/* Header */}
      <div className="page-header -mx-6 md:-mx-8 -mt-6 md:-mt-8 mb-6 px-6 md:px-8 py-6">
        <h1 className="text-2xl sm:text-3xl font-bold tracking-tight" style={{ color: 'var(--t-text)', fontFamily: 'var(--t-heading-font)' }}>
          Settings
        </h1>
        <p className="mt-1" style={{ color: 'var(--t-text-muted)' }}>Manage your account and application settings</p>
      </div>

      <div className="max-w-3xl space-y-6">
        <ProfileSection user={user} />
        {user?.role === "super_admin" && <TeamManagement />}
        <ThemeSection theme={theme} onThemeChange={handleThemeChange} />
        {user?.role === "super_admin" && (
          <LogoSection subscription={subscription} companyLogo={companyLogo} updateLogo={updateLogo} />
        )}
        <EmailSection user={user} subscription={subscription} />
        <NotificationsSection />
        <IntegrationsSection />
        <SubscriptionSection subscription={subscription} onSubscriptionChange={fetchSubscription} />
        <ReferralSection />
        <SupportSection user={user} />
        <AboutSection />
      </div>
    </div>
  );
};

export default Settings;
